import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="plaid"
export default class extends Controller {
  static values = {
    paystubsLinkToken: String,
    bankStatementsLinkToken: String,
    charityCareApplicationId: Number,
  }

  static targets = [
    "paystubsButton",
    "bankStatementsButton"
  ]

  connect() {
  }

  openPaystubs(e) {
    this.openPlaid(e, this.paystubsLinkTokenValue, 'CharityCareApplication', this.charityCareApplicationIdValue, 'paystubs', 'income_verification', [])
  }

  openBankStatements(e) {
    this.openPlaid(e, this.bankStatementsLinkTokenValue, 'CharityCareApplication', this.charityCareApplicationIdValue, 'bank_statements', 'assets', ['statements'])
  }

  openPlaid(e, tokenValue, resourceType, resourceId, resourceAttachmentName, product, requiredIfSupportedProducts) {
    const handler = Plaid.create({
      token: tokenValue,
      onSuccess: (public_token, metadata) => {
        // Send the public_token to your app server.
        // The metadata object contains info about the
        // institution the user selected and the
        // account ID or IDs, if the Account Select view
        // is enabled.

        document.getElementById('plaid_items_info_spinner_container').classList.remove('hidden')

        fetch('/api/v1/plaid/set_access_token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            public_token: public_token,
            metadata: metadata,
            resource_type: resourceType,
            resource_id: resourceId,
            resource_attachment_name: resourceAttachmentName,
            product: product,
            required_if_supported_products: requiredIfSupportedProducts
          })
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch((error) => {
          if (appsignal) {
            appsignal.sendError(error)
          } else {
            console.error('Error:', error)
          }
        })
      },
      onLoad: () => { },
      onExit: (err, metadata) => {},
      onEvent: (eventName, metadata) => {},
    })

    handler.open()
  }
}
